import type { OwaDate } from 'owa-datetime';
import { startOfDay, addDays } from 'owa-datetime';
import FreeBusyType from '../schema/FreeBusyType';
import { getDetailedFreeBusy } from './getDetailedFreeBusy';
import getMostSevereFreeBusy from './getMostSevereFreeBusy';

/**
 * Gets the most severe free busy status between start and end time
 * @param sessionId Id for this free/busy cache session
 * @param attendee: The SMTP address for which Free Busy was requested
 * @param start: The start time of the event
 * @param end: The end time of the event
 * @param isAllDayEvent: true if the event spans the entire day
 */
export function getAggregatedFreeBusy(
    sessionId: string,
    attendee: string,
    start: OwaDate,
    end: OwaDate,
    isAllDayEvent: boolean
): FreeBusyType {
    start = isAllDayEvent ? startOfDay(start) : start;
    end = isAllDayEvent ? startOfDay(addDays(end, 1)) : end;
    const mergedFreeBusy = getDetailedFreeBusy(sessionId, attendee, start, end);

    return mergedFreeBusy.reduce(
        (previous, current) => getMostSevereFreeBusy(previous, current),
        FreeBusyType.Loading
    );
}
